import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  withStyles,
} from '@material-ui/core'
import { selectFromNumber } from 'actions/inbox'

class FromNumberDropdown extends Component {
  componentDidMount() {
    this.forceUpdate()
  }

  render() {
    const {
      selectFromNumber,
      selectedFromNumber,
      fromNumbers,
      classes,
    } = this.props

    return (
      <FormControl fullWidth variant="outlined">
        <InputLabel
          ref={(ref) => {
            this.labelRef = ReactDOM.findDOMNode(ref)
          }}
          htmlFor="taskSelectedActionSelect"
          shrink
          style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
        >
          Caller ID
        </InputLabel>
        <Select
          value={selectedFromNumber}
          onChange={(e) => selectFromNumber(e.target.value)}
          input={
            <OutlinedInput
              notched
              labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
              id="taskSelectedActionSelect"
              classes={{ notchedOutline: classes.notchedOutline }}
            />
          }
        >
          {typeof fromNumbers === 'object' &&
            Object.values(fromNumbers).map((fromNumber) => (
              <MenuItem
                key={`fromNumberSelectFieldValue${fromNumber.id}`}
                value={fromNumber}
              >
                {fromNumber.phone_number}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    )
  }
}

const styles = (theme) => ({
  notchedOutline: {
    borderRadius: 28,
    paddingLeft: '40px !important',
  },
})

export default connect(
  (state) => ({
    selectedFromNumber: state.inbox.fromNumberSelected,
    fromNumbers: state.data.phonenumbers,
  }),
  (dispatch) => bindActionCreators({ selectFromNumber }, dispatch),
)(withStyles(styles)(FromNumberDropdown))
